module.exports = __webpack_public_path__ + "assets/3c72969cdca745ade500c4569774bda3.png";